
<block-ui></block-ui>

<h1 mat-dialog-title></h1>
<mat-dialog-content class="mat-typography">
    <form [formGroup]="Form">
        <fieldset class="col-12">
            <legend>
                <span>Registro</span>
            </legend>
            <div class="card">
                <div class="card-body">
                    <div class="form-row">
                        <div class="form-group col-md-4">
                            <label>Categoria</label>
                            <select class="form-control"
                             formControlName="coqutias_in_type"
                             (change)="change_type($event.target.value)" 
                             [(ngModel)]="default_select_type">
                                <option value="">Seleccionar</option>
                                <ng-container *ngFor="let parameter of parameters">
                                    <option *ngIf="parameter.sys_in_group==1500"
                                        value="{{parameter.sys_in_parameter}}">{{parameter.sys_vc_description}}
                                    </option>
                                </ng-container>
                            </select>
                        </div>
                        <div *ngIf="default_select_type=='1'" class="form-group col-md-8">
                            <label>Curso</label>
                            <select class="form-control" formControlName="coqutias_vc_references" 
                            [(ngModel)]="default_select_courses" >
                                <option value="">SELECCIONAR</option>
                                <ng-container *ngFor="let course of courses">
                                    <option [ngValue]="course.cou_in_id">
                                        {{course.cou_vc_name}}
                                    </option>
                                </ng-container>
                            </select>
                        </div>
                        <div *ngIf="default_select_type=='2'" class="form-group col-md-8">
                            <label>Profesor</label>
                            <select class="form-control" formControlName="coqutias_vc_references" 
                                [(ngModel)]="default_select_employee"  >
                                <option value="">SELECCIONAR</option>
                                <ng-container *ngFor="let prof of employee">
                                    <option [ngValue]="prof.emp_bi_id">
                                        {{prof.per_vc_full_names}}
                                    </option>
                                </ng-container>
                            </select>
                        </div>
                    </div>
    
                     
    
                    <div class="row">
                     
                        <div class="form-group col-md-3">
                            <button class="btn btn-badminton btn-sm pull-right" (click)="Save()">Guardar</button>
                        </div>
                    </div>
                </div>
            </div>
    
        </fieldset>
    
        <fieldset class="col-12">
            <legend>Listado</legend>
            <div class="card card-osiptel-default">
                <div class="card-body">
    
                    <table mat-table [dataSource]="dataSource" class="mat-elevation-z8">
                         
    
                        <ng-container matColumnDef="coqutias_vc_type">
                            <th mat-header-cell *matHeaderCellDef> Tipo </th>
                            <td mat-cell *matCellDef="let element"> {{element.coqutias_vc_type}} </td>
                        </ng-container>
    
                        <ng-container matColumnDef="emp_vc_name">
                            <th mat-header-cell *matHeaderCellDef> Curso/Profesor </th>
                            <td mat-cell *matCellDef="let element"> {{element.emp_vc_name}} </td>
                        </ng-container>
                        
                        
                        <ng-container matColumnDef="opcion">
                            <th mat-header-cell *matHeaderCellDef> Opciones</th>
                            <td mat-cell *matCellDef="let element">
                              <a  (click)="delete(element)"  class="pr-2"><i class="fa fa-remove"></i> Eliminar</a>
                            </td>
                          </ng-container>
    
                        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                        <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
                    </table>
                    <mat-paginator #paginatorDatasource [pageSizeOptions]="[5, 10, 20]" showFirstLastButtons>
                    </mat-paginator>
                </div>
            </div>
        </fieldset>
    
    
    </form>
  </mat-dialog-content>
 

 
 
